const MAX_PHOTO_UPLOAD_MB = 10

import { isSystemAdmin as checkSystemAdmin } from '@/utils/sysRole'

export function isSystemAdmin() {
  try {
    const user = JSON.parse(localStorage.getItem('user_info') || '{}')
    return checkSystemAdmin(user.sysRole)
  } catch {
    return false
  }
}

/** el-upload :headers — 上传走原生 form，不会带 axios 拦截器里的 token */
export function adminUploadHeaders() {
  const token = localStorage.getItem('jwt_token')
  return token ? { Authorization: `Bearer ${token}` } : {}
}

/** el-upload :data — scope: blog | exam | courses | carousel | news */
export function adminUploadFormData(scope) {
  return isSystemAdmin() && scope ? { scope } : {}
}

export function appendAdminUploadScope(formData, scope) {
  if (isSystemAdmin() && scope) {
    formData.append('scope', scope)
  }
}

/** 将上传接口或数据库中的相对路径转为可访问 URL（GET /api/v1/upload/...） */
export function photoPathToUrl(path) {
  if (!path || typeof path !== 'string') return ''
  let p = path.trim().replace(/\\/g, '/')
  if (p.startsWith('http://') || p.startsWith('https://')) return p
  if (p.startsWith('/api/')) return p
  if (p.startsWith('/static/')) return `/api/v1${p}`
  // 去掉 ./ 与 upload/ 前缀（接口路径已含 /upload/）
  p = p.replace(/^\.?\//, '')
  if (p.toLowerCase().startsWith('upload/')) {
    p = p.slice(7)
  }
  const uploadIdx = p.toLowerCase().indexOf('/upload/')
  if (uploadIdx >= 0) {
    p = p.slice(uploadIdx + 8)
  }
  return `/api/v1/upload/${p.replace(/^\//, '')}`
}

export function uploadResponseToUrl(response) {
  const path = response?.filename || response?.message
  return photoPathToUrl(path)
}

export function validatePhotoUpload(file, messageFn) {
  const name = file.name?.toLowerCase() || ''
  const isPNG = file.type === 'image/png' || name.endsWith('.png')
  const isJPG = file.type === 'image/jpeg' || name.endsWith('.jpg') || name.endsWith('.jpeg')
  const isWebP = file.type === 'image/webp' || name.endsWith('.webp')
  const isLt10M = file.size / 1024 / 1024 < MAX_PHOTO_UPLOAD_MB

  if (!isPNG && !isJPG && !isWebP) {
    messageFn?.('上传图片只能是 PNG/JPG/WEBP 格式!')
    return false
  }
  if (!isLt10M) {
    messageFn?.('上传图片大小不能超过 10MB!')
    return false
  }
  return true
}
